import overviewSsrFetch from './Overview/ssrFetch';
import lastTransactionsSsrFetch from './LastTransactions/ssrFetch';
import newTransactionSsrFetch from './NewTransaction/ssrFetch';

export default function ssrFetch({
    store, headers, baseUrl, params, timeout
}) {
    const options = {
        store, headers, baseUrl, params, timeout
    };

    return Promise.all([
        overviewSsrFetch(options),
        lastTransactionsSsrFetch(options),
        newTransactionSsrFetch(options)
    ]);
}
